<div class="webinars-page">
    <div class="client-container d-flex flex-col gap-24">
        @if (isLoading) {
            <div class="d-flex align-items-center justify-content-center p-y-48">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
        } @else {
            <mat-card class="cardPlain">
        <div class="mat-mdc-card-header custom-card-header">
            <div class="section-header d-flex flex-col gap-4">
                <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
                <h1 class="m-0 f-w-500">Webinar settings</h1>
                <p class="m-0 help-text">
                    Configure how webinars behave across your organization — integrations, branding, and defaults.
                </p>
            </div>
            <span class="spacer"></span>
            <button
                    (click)="refresh()"
                    [disabled]="isSaving"
                    class="d-inline-flex align-items-center gap-6"
                    color="primary"
                    mat-stroked-button
                    type="button"
            >
                <mat-icon>refresh</mat-icon>
                <span>Refresh</span>
            </button>
        </div>
                <mat-card-content class="d-flex flex-col gap-24">
                    <form (ngSubmit)="save()" [formGroup]="form" class="d-flex flex-col gap-24 form-no-subscripts">
                        <mat-tab-group animationDuration="0ms" class="webinar-tabs">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon>link</mat-icon>
                                    <span>Connections</span>
                                </ng-template>
                                <ng-template matTabContent>
                                    <div class="d-flex flex-col gap-24">
                                        @if (status; as status) {
                                            <div class="d-flex flex-col gap-12">
                                                <h4 class="m-0 f-s-16 f-w-600">Active connections</h4>
                                                <div class="connection-list connections d-flex flex-col gap-12">
                                                    @if (status.connected) {
                                                        @for (connection of status.connections || []; track connection) {
                                                            <div class="success-message">
                                                                <mat-icon class="banner__icon status-check">
                                                                    check_circle
                                                                </mat-icon>
                                                                <div class="content d-flex flex-col gap-4">
                                                                    <div class="title d-flex align-items-center gap-6">
                                                                        <span>Connected to HubSpot</span>
                                                                    </div>
                                                                    <p class="m-0 f-s-14 text-gray-100 subtitle">
                                                                        HubSpot OAuth connection detected.
                                                                    </p>
                                                                    @if (connection.updatedAt) {
                                                                        <div class="meta">
                                                                            Updated {{ connection.updatedAt | date: 'medium' }}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                        @if (!status.connections.length) {
                                                            <div class="warning-message">
                                                                <mat-icon class="banner__icon">warning</mat-icon>
                                                                <div class="content d-flex flex-col gap-4">
                                                                    <div class="title d-flex align-items-center gap-6">
                                                                        <span>No active connections</span>
                                                                    </div>
                                                                    <p class="m-0 f-s-14 text-gray-100 subtitle">
                                                                        Connect HubSpot in Shine Auth to enable webinar
                                                                        syncing.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        }
                                                    } @else {
                                                        <div class="warning-message">
                                                            <mat-icon class="banner__icon">warning</mat-icon>
                                                            <div class="content d-flex flex-col gap-4">
                                                                <div class="title d-flex align-items-center gap-6">
                                                                    <span>Not connected to HubSpot</span>
                                                                </div>
                                                                <p class="m-0 f-s-14 text-gray-100 subtitle">
                                                                    Connect HubSpot in Shine Auth to enable webinar
                                                                    syncing.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <section class="d-flex flex-col gap-16">
                                            <div class="section-header">
                                                <h4 class="m-0 f-s-16 f-w-600">HubSpot marketing events</h4>
                                                <p class="section-lead">
                                                    Sync webinars, registrations, and attendance to HubSpot marketing
                                                    events. Chat messages remain as CRM timeline events.
                                                </p>
                                            </div>
                                            <div class="d-flex align-items-center gap-12 flex-wrap">
                                                <mat-slide-toggle
                                                        [disabled]="!!form.get('hubspotEnabled')?.disabled"
                                                        appearance="switch"
                                                        color="primary"
                                                        formControlName="hubspotEnabled">
                                                    Sync to HubSpot marketing events
                                                </mat-slide-toggle>
                                                @if (showProvisionButton) {
                                                    <button
                                                            (click)="provisionHubspotRegistration()"
                                                            [disabled]="!canProvisionRegistration || isProvisioning"
                                                            class="d-inline-flex align-items-center gap-6"
                                                            color="primary"
                                                            mat-stroked-button
                                                            type="button"
                                                    >
                                                        <mat-icon>{{ isProvisioning ? 'hourglass_top' : 'build' }}</mat-icon>
                                                        <span>
                                                            {{
                                                                isProvisioning
                                                                    ? 'Provisioning…'
                                                                    : 'Provision HubSpot registration property'
                                                            }}
                                                        </span>
                                                    </button>
                                                }
                                            </div>
                                            @if (!status?.connected) {
                                                <p class="m-0 f-s-14 text-gray-100">
                                                    Connect HubSpot in Shine Auth to enable marketing events sync.
                                                </p>
                                            }
                                        </section>
                                    </div>
                                </ng-template>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon>brush</mat-icon>
                                    <span>Branding</span>
                                </ng-template>
                                <ng-template matTabContent>
                                    <section class="d-flex flex-col gap-16">
                                        <div class="section-header">
                                            <h4 class="m-0 f-s-16 f-w-600">Branding</h4>
                                            <p class="m-0 f-s-14 text-gray-100 section-lead">
                                                Configure the logo and favicon used for the attendee experience.
                                            </p>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="d-flex flex-col gap-16">
                                                    <div class="file-picker">
                                                        <label class="file-label m-0 f-s-14">Logo image</label>
                                                        @if (logoPreviewUrl) {
                                                            <div class="preview">
                                                                <img [src]="logoPreviewUrl" alt="Logo preview"
                                                                     class="preview-thumb"/>
                                                            </div>
                                                        }
                                                        <div class="file-input-row">
                                                            <button (click)="logoInput.click()" class="d-inline-flex align-items-center gap-6" color="primary"
                                                                    mat-stroked-button
                                                                    type="button">
                                                                <mat-icon>upload</mat-icon>
                                                                <span>Choose file</span>
                                                            </button>
                                                            <span class="file-name text-gray-100 f-s-14">{{ logoFileName || 'No file chosen' }}</span>
                                                        </div>
                                                        <input #logoInput (change)="onLogoFileSelected($event)" accept="image/*"
                                                               hidden type="file"/>
                                                        <p class="m-0 f-s-14 text-gray-100">Upload the logo shown
                                                            top-left on the webinar page.</p>
                                                    </div>
                                                    <div class="file-picker">
                                                        <label class="file-label m-0 f-s-14">Favicon image</label>
                                                        @if (faviconPreviewUrl) {
                                                            <div class="preview">
                                                                <img [src]="faviconPreviewUrl" alt="Favicon preview"
                                                                     class="preview-thumb"/>
                                                            </div>
                                                        }
                                                        <div class="file-input-row">
                                                            <button (click)="faviconInput.click()" class="d-inline-flex align-items-center gap-6" color="primary"
                                                                    mat-stroked-button
                                                                    type="button">
                                                                <mat-icon>upload</mat-icon>
                                                                <span>Choose file</span>
                                                            </button>
                                                            <span class="file-name text-gray-100 f-s-14">{{ faviconFileName || 'No file chosen' }}</span>
                                                        </div>
                                                        <input #faviconInput (change)="onFaviconFileSelected($event)" accept="image/*"
                                                               hidden type="file"/>
                                                        <p class="m-0 f-s-14 text-gray-100">Upload the optional browser
                                                            tab icon.</p>
                                                    </div>
                                                </div>
                                            </div>
                    </div>
                                    </section>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>
                        <mat-card-actions align="end" class="p-0">
                            <button
                                    [disabled]="form.disabled || form.pristine || isSaving || !status?.connected"
                                    class="d-inline-flex align-items-center gap-6"
                                    color="primary"
                                    mat-flat-button
                                    type="submit"
                            >
                                <mat-icon>{{ isSaving ? 'hourglass_top' : 'save' }}</mat-icon>
                                {{ isSaving ? 'Saving…' : 'Save changes' }}
                            </button>
                        </mat-card-actions>
                    </form>
                </mat-card-content>
            </mat-card>
        }

    </div>
</div>
